/**
 * 菲律賓語（他加祿語）
 */
export default {
  name: 'fil',
  el: {
    colorpicker: { pagkumpirma: 'Kumpirmahin', linis: 'Linisin' },
    datepicker: {
      ngayon: 'Ngayon',
      ngayongAraw: 'Ngayong araw',
      kanselahin: 'Ikansela',
      malinis: 'Linisin',
      kumpirmahin: 'Kumpirmahin',
      piliinAngPetsa: 'Piliin ang petsa',
      pumiliNgOras: 'Pumili ng oras',
      simulanAngPetsa: 'Simulan ang petsa',
      simulanAngOras: 'Simulan ang oras',
      tapusinAngPetsa: 'Tapusin ang petsa',
      tapusinAngOras: 'Tapusin ang oras',
      nakaraangTaon: 'Nakaraang taon',
      susunodNaTaon: 'Susunod na taon',
      nakaraangBuwan: 'Nakaraang buwan',
      susunodNaBuwan: 'Susunod na buwan',
      taon: 'Taon',
      buwan1: 'Enero',
      buwan2: 'Pebrero',
      buwan3: 'Marso',
      buwan4: 'Abril',
      buwan5: 'Mayo',
      buwan6: 'Hunyo',
      buwan7: 'Hulyo',
      buwan8: 'Agosto',
      buwan9: 'Setyembre',
      buwan10: 'Oktubre',
      buwan11: 'Nobyembre',
      buwan12: 'Disyembre',
      mgaLinggo: {
        linggo: 'Linggo',
        lunes: 'Lunes',
        martes: 'Martes',
        miyerkules: 'Miyerkules',
        huwebes: 'Huwebes',
        biyernes: 'Biyernes',
        sabado: 'Sabado'
      },
      mgaBuwan: {
        jan: 'Enero',
        feb: 'Pebrero',
        mar: 'Marso',
        apr: 'Abril',
        may: 'Mayo',
        jun: 'Hunyo',
        jul: 'Hulyo',
        aug: 'Agosto',
        sep: 'Setyembre',
        oct: 'Oktubre',
        nov: 'Nobyembre',
        dec: 'Disyembre'
      }
    },
    pumili: {
      nagloload: 'Nagloload',
      walangNakuhangTugma: 'Walang nakuhang tugma',
      walangData: 'Walang data',
      placeholder: 'Mangyaring pumili'
    },
    cascader: {
      noMatch: 'Walang natagpuang katugmang data',
      loading: 'Nagloload',
      placeholder: 'Mangyaring pumili',
      noData: 'Walang data'
    },
    pagination: {
      goto: 'Pumunta sa',
      pagesize: 'item/bilang ng pahina',
      total: 'Kabuuan ng {total} item',
      pageClassifier: 'pahina',
      page: 'pahina',
      prev: 'Nakaraang pahina',
      next: 'Susunod na pahina',
      currentPage: 'Pahina {pager}',
      prevPages: 'Pumunta sa {pager} na nakaraang pahina',
      nextPages: 'Pumunta sa {pager} na susunod na pahina',
      deprecationWarning:
        'Ikaw ay gumagamit ng ilang mga hindi na ginagamit na kasanayan, mangyaring tingnan ang opisyal na dokumentasyon ng el-pagination'
    },
    messagebox: {
      title: 'Paalala',
      confirm: 'Kumpirmahin',
      cancel: 'Kanselahin',
      error: 'Hindi wastong data ang inilagay!'
    },
    upload: {
      deleteTip: 'Pindutin ang delete upang burahin',
      delete: 'Burahin',
      preview: 'Tingnan ang larawan',
      continue: 'Magpatuloy sa pag-upload'
    },
    table: {
      emptyText: 'Walang data',
      confirmFilter: 'Filtruhin',
      resetFilter: 'I-reset',
      clearFilter: 'Lahat',
      sumText: 'Kabuuan'
    },
    tree: { emptyText: 'Walang data' },
    transfer: {
      noMatch: 'Walang natagpuang katugmang data',
      noData: 'Walang data',
      titles: ['Listahan 1', 'Listahan 2'],
      filterPlaceholder: 'Maglagay ng nilalaman sa paghahanap',
      noCheckedFormat: 'Kabuuan ng {total} na item',
      hasCheckedFormat: 'Napiling {checked}/{total} na item'
    },
    image: { error: 'Nabigo sa pag-load' },
    pageHeader: { title: 'Bumalik' },
    popconfirm: { confirmButtonText: 'Kumpirmahin', cancelButtonText: 'Kanselahin' }
  }
}
